export function SearchSkeleton() {
  const skeletonItems = Array.from({ length: 8 }, (_, index) => (
    <div
      key={index}
      className="animate-pulse overflow-hidden rounded-lg border bg-white shadow-sm"
    >
      <div className="h-48 rounded-t-lg bg-gray-200"></div>

      <div className="h-20 flex-col space-y-2 p-5">
        <div className="h-3 w-3/4 rounded bg-gray-200"></div>
        <div className="h-3 w-1/2 rounded bg-gray-200"></div>
      </div>
    </div>
  ));

  return <div className="grid grid-cols-4 gap-4">{skeletonItems}</div>;
}
